import React from "react"
import { useNavShell } from "@stjeans/shared-frontend/nav"

/**
 * @param {{
 *   label: string,
 *   Icon: any,
 *   onClick?: (() => void) | undefined,
 *   bgColor: string,
 *   textColor?: string,
 *   placement?: "sidebar" | "mobileTopBar",
 * }} props
 */
export default function StatusNoticeItem({
  label,
  Icon,
  onClick,
  bgColor,
  textColor = "#fff",
  placement = "sidebar",
}) {
  const { closeSidebar, isCollapsed } = useNavShell()
  const onClickFn = /** @type {any} */ (onClick)
  const isInteractive = typeof onClickFn === "function"
  const isMobileTopBar = placement === "mobileTopBar"

  function handleActivate() {
    onClickFn?.()
    if (!isMobileTopBar) {
      closeSidebar()
    }
  }

  return (
    <div
      {...(isInteractive
        ? {
          role: "button",
          tabIndex: 0,
          onClick: handleActivate,
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              handleActivate()
            }
          },
        }
        : { role: "status" })}
      className={
        "btn d-flex align-items-center border-0 status-notice-item " +
        (isMobileTopBar
          ? "status-notice-item--mobile-top-bar flex-shrink-0 "
          : "w-100 ") +
        (!isMobileTopBar && isCollapsed ? "justify-content-center " : "")
      }
      style={{
        backgroundColor: bgColor,
        color: textColor,
        fontSize: isMobileTopBar ? "0.8125rem" : "0.875rem",
        fontWeight: 600,
        padding: isMobileTopBar
          ? "0.375rem 0.625rem"
          : isCollapsed
            ? "0.5rem"
            : "0.75rem 1rem",
        borderRadius: isMobileTopBar ? "0.5rem" : "0.75rem",
        cursor: isInteractive ? "pointer" : "default",
        boxShadow: "none",
      }}
      title={isCollapsed && !isMobileTopBar ? label : ""}
    >
      {isCollapsed && !isMobileTopBar ? (
        <span
          className="d-inline-flex align-items-center justify-content-center"
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "999px",
            backgroundColor: bgColor,
            color: textColor,
          }}
        >
          <Icon size={22} />
        </span>
      ) : (
        <>
          <Icon size={isMobileTopBar ? 16 : 20} />
          <span className={isMobileTopBar ? "ms-1" : "nav-text ms-2"}>{label}</span>
        </>
      )}
    </div>
  )
}